// extracted by mini-css-extract-plugin
export default {"react_pdf_thumbnail":"file_react_pdf_thumbnail__xXOHA","react_pdf_thumbnail_active":"file_react_pdf_thumbnail_active__xaD4m"};